<template>
  <div>
    <h6>
      Your Registered Details:
    </h6>
    <v-row>
      <v-col cols="12" md="4">
        First Name: <span class="text-primary">{{ existingCustomerVault.firstName }}</span>
      </v-col>
      <v-col cols="12" md="4">
        Last Name: <span class="text-primary">{{ existingCustomerVault.lastName }}</span>
      </v-col>
      <v-col cols="12" md="4">
        E-Mail: <span class="text-primary">{{ existingCustomerVault.email }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CustomerDetails",
  props: {
    existingCustomerVault: Object
  }
}
</script>

<style scoped>

</style>
